import { MutationTree } from 'vuex';
import { State } from './state';
import { ReportingMutationTypes } from './mutation-types';
import {
  ReportingTableApiResponse,
  ReportingActivityApiResponse,
} from './types';

export type Mutations<S = State> = {
  [ReportingMutationTypes.SET_REPORTING_TABLE](
    state: S,
    payload: ReportingTableApiResponse
  ): void;
  [ReportingMutationTypes.SET_REPORTING_ACTIVITY](
    state: S,
    payload: ReportingActivityApiResponse
  ): void;
  [ReportingMutationTypes.CLEAR_REPORTING_TABLE](state: S): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [ReportingMutationTypes.SET_REPORTING_TABLE](
    state: State,
    payload: ReportingTableApiResponse
  ) {
    state.table = payload;
  },
  [ReportingMutationTypes.SET_REPORTING_ACTIVITY](
    state: State,
    payload: ReportingActivityApiResponse
  ) {
    state.activity = payload;
  },
  [ReportingMutationTypes.CLEAR_REPORTING_TABLE](state: State) {
    state.table = {} as ReportingTableApiResponse;
  },
};
